export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#6AC64B',
    contrastText: '#FFFFFF',
    light: '#F4F8F3',
    hover: '#253746',
  },
  button: {
    hover: '#88D16F',
  },
  secondary: {
    main: '#63864F',
    contrastText: '#FFFFFF',
  },
  text: {
    primary: '#253746',
    primaryLight: '#697883',
    light: '#616F83',
    secondary: '#626D7C',
    description: '#000000',
    detail: '#374151',
    dark: '#253746',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#119642',
    error: '#EB4D4B',
    border: '#D1D5DB',
    heading: '#0F0F0F',
    tertiary: '#9CA3AF',
    normal: '#404850',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  borderColor: '#BCE194',
  background: {
    main: '#FFFFFF',
    dark: '#80A868',
    header: '#253746',
    light: '#F4F8F3',
    description: '#D1E4DD',
    ribbon: '#6AC64B',
    paper: '#FFF',
    default: '#FFF',
    footer: '#BCE194',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#222930',
    tableSubhead: '#F7F7F7',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: '#253746',
    primary: '#6AC64B',
    primaryLight: '#d1e4dd',
    secondaryLight: '#CDE1CB',
    staticFooter: '#EEF2F6',
    contactBanner: '#EEF2F6',
    serviceIcon: '#F8FAFC',
    serviceIconActive: '#F4F8F3',
    tertiary: '#F9FAFB',
    greySubtle: '#F4F5F7',
    neutral: '#374151',
  },
  border: {
    primary: '#D1D5DB',
    field: '#E2E8F0',
    subtle: '#E2E8F0',
    card: '#EBEBEF',
    brand: '#63864F',
    brandAlt: '#6AC64B',
  },
  brand: {
    main: '#63864F',
    hover: '#253746',
    surface: '#F4F8F3',
    accent: '#6AC64B',
  },
  icon: {
    primary: '#374151',
    tertiary: '#4B5563',
    brand: '#63864F',
  },
  verticalBar: {
    used: '#6AC64B',
    unused: 'rgba(209, 228, 221, 0.4)',
    unlimited: '#C0C0C0',
  }
};
